/* eslint-disable */
class InputMask {
  public getMaskedValue = (fieldName: string, originalValue: any): string => {
    switch (fieldName) {
      case 'cpf':
        return this.cpfMask(originalValue);
      case 'cellphone':
        return this.phoneMask(originalValue);
      case 'name':
        return this.noNumberMask(originalValue);
      case 'cvv':
        return this.cvv(originalValue);
      case 'date':
        return this.date(originalValue);
      case 'plate':
        return this.plate(originalValue);
      case 'cardNumber':
        return this.cardNumber(originalValue);
      case 'cep':
        return this.cep(originalValue);
      case 'cnpj':
        return this.cnpjMask(originalValue);
      default:
        return originalValue;
    }
  }

  private cep = (text: string): string => {
    return text.replace(/[!@#$%&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
  };

  private cpfMask = (text: string): string => {
    text = text.replace(/\D/g, '');
    text = text.replace(/(\d{3})(\d)/, '$1.$2');
    text = text.replace(/(\d{3})(\d)/, '$1.$2');
    text = text.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return text;
  };

  private cnpjMask = (text: string): string => {
    text = text.replace(/\D/g, '');
    text = text.replace(/(\d{2})(\d)/, '$1.$2');
    text = text.replace(/(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    text = text.replace(/\.(\d{3})(\d)/, '.$1/$2');
    text = text.replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    return text;
  };

  private phoneMask = (text: string): string => {
    text = text.replace(/\D/g, '');
    text = text.replace(/^(\d\d)(\d)/g, '($1) $2');
    text = text.replace(/(\d{4})(\d)/, '$1-$2');
    return text;
  }

  private noNumberMask = (text: string) => {
    return text
      .replace(/[!@#$%&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
      .replace(/[0-9]/g, '');
  }

  private cvv = (text: string): string => {
    text = text.replace(/\D/g, '');
    return text;
  };

  private plate = (text: string): string => {
    const letters = text.substring(0, 3).replace(/[0-9]/g, '');
    const num1 = text.substring(4, 3).replace(/\D/g, '');
    const numOrLetter = text.substring(5, 4);
    const num2 = text.substring(5, 8).replace(/\D/g, '');

    return `${letters}${num1}${numOrLetter}${num2}`;
  };

  private date = (text: string): string => {
    text = text.replace(/\D/g, "");
    text = text.replace(/(\d{2})(\d)/, "$1/$2");
    text = text.replace(/(\d{2})(\d)/, "$1/$2");

    text = text.replace(/(\d{2})(\d{2})$/, "$1$2");
    return text;
  }

  private cardNumber(text: string) {
    text = text.replace(/\D/g, "");
    text = text.replace(/^(\d{4})(\d)/g, "$1 $2");
    text = text.replace(/^(\d{4})\s(\d{4})(\d)/g, "$1 $2 $3");
    text = text.replace(/^(\d{4})\s(\d{4})\s(\d{4})(\d)/g, "$1 $2 $3 $4");
    return text;
  }
}

export default new InputMask();
